export const PLATFORM_DEFAULTS_FIELD_LABEL_SX = {
  color: "text.primary",
  fontSize: "14px",
};
